// 权限处理和认证
import { getAllowOperate } from '@/api';

export default {
  data() {
    return {
      PERMISSION: [],
      isPerFetch: false
    };
  },
  mounted() {
    this.getPermission();
  },
  methods: {
    async getPermission() {
      if (this.ACTIVEMENUID && !this.isPerFetch) {
        this.isPerFetch = true;
        const res = await getAllowOperate({
          menu_id: this.ACTIVEMENUID
        });
        if (res && res.data) {
          this.PERMISSION = res.data;
        }
        if (this.getAllowPer) this.getAllowPer();
      }
    }
  },
  watch: {
    ACTIVEMENUID() {
      this.getPermission();
    }
  },
  computed: {
    ACTIVEMENUID() {
      // 新窗口的可以从很多的菜单入口进来，目前先写死，后台数据库权限表也只挂载到id: 52(班级信息)下面
      if (this.$route.path.includes('/classes/enrolment/') && !this.$store.getters.activeMenuId) return 52;
      return this.$store.getters.activeMenuId;
    },
    hasPermission() {
      return key => this.PERMISSION.includes(key);
    }
  }
};
